var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.cardAmount),function(i){return _c('v-col',{key:i,staticClass:"item",attrs:{"cols":"12","sm":_vm.isTile ? '6' : '12',"md":_vm.mdCardSize,"lg":_vm.lgCardSize}},[_c(_vm.cardType,{tag:"component"})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }